// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwSearchBox from 'viewmodel/AwSearchBoxViewModel';
    

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/desCatalogEventBus', () => import('js/desCatalogEventBus'));
registerDynImportEntry('js/desSearchService', () => import('js/desSearchService'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "lifecycleHooks": {
        "onUpdate": {
            "observers": [
                "props.accsessionid"
            ]
        }
    },
    "data": {
        "searchBox": {
            "displayName": "{{i18n.searchBoxdisplayName}}",
            "type": "STRING",
            "dbValue": ""
        },
        "searchBoxPlaceHolder": {
            "dbValue": "{{i18n.searchBoxplaceholder}}"
        }
    },
    "actions": {
        "doSearch": {
            "actionType": "Event",
            "method": "Event",
            "inputData": {
                "events": [
                    {
                        "name": "searchInitiated",
                        "eventData": {
                            "eventName": "searchInitiated",
                            "searchInput": "{{data.searchBox.dbValue}}"
                        },
                        "condition": "data.searchBox.dbValue && data.searchBox.dbValue.length > 0"
                    }
                ]
            }
        },
        "publishToACCEventBus": {
            "actionType": "JSFunction",
            "method": "publish",
            "inputData": {
                "eventId": "{{parameters.eventName}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/desCatalogEventBus"
        },
        "clearSeachBox": {
            "actionType": "JSFunction",
            "method": "clearSeachBox",
            "inputData": {
                "vmo": "{{data}}"
            },
            "deps": "js/desSearchService"
        }
    },
    "props": {
        "accsessionid": {
            "type": "string"
        }
    },
    "onEvent": [
        {
            "eventId": "clearSeachBoxEvent",
            "action": "clearSeachBox"
        }
    ],
    "i18n": {
        "searchBoxplaceholder": [
            "DesLibraryMessages"
        ],
        "searchBoxdisplayName": [
            "DesLibraryMessages"
        ]
    },
    "_viewModelId": "DesShareLibrarySearchBox",
    "_uniqueViewModelId": "DesShareLibrarySearchBox",
    "ctx": {}
};

    /*
    <aw-search-box prop="data.searchBox" placeholder="data.searchBoxPlaceHolder.dbValue" action="doSearch">
</aw-search-box>
    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwSearchBox {...getField("data.searchBox", fields, $index, null, null )} placeholder={AwParseService.instance( "data.searchBoxPlaceHolder.dbValue" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} action={actions.doSearch}>
    </AwSearchBox>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;